import * as React from "react";

import { TextField } from "@material-ui/core";
import { useInput } from "react-admin";
import { useTranslate } from "react-admin";

const getMessage = (error) =>
  error && typeof error === "string"
    ? { message: error, args: undefined }
    : error && error.args
    ? { message: error.message, args: error.args }
    : { message: "", args: undefined };

const BoundedTextInput = (props) => {
  const translate = useTranslate();
  const {
    input: { name, onChange, ...rest },
    meta: { touched, error },
    isRequired,
  } = useInput(props);
  const { disabled, fullWidth, variant, inputProps } = props;
  const errorMessage = getMessage(error);
  const message = translate(errorMessage.message, errorMessage.args);

  return (
    <TextField
      name={name}
      label={props.label}
      margin="dense"
      variant={variant}
      fullWidth={fullWidth}
      onChange={onChange}
      error={!!(touched && message)}
      helperText={touched && message}
      required={isRequired}
      disabled={disabled}
      inputProps={inputProps}
      {...rest}
    />
  );
};

export default BoundedTextInput;
